
@if (iconName()) {
  <ci-icon
    [class]="'content__icon' + ' ' + iconName()"
    [name]="iconName()"
    type="svg"
  ></ci-icon>
}